const ITEMS = [
  'Digital Marketing', 'SEO Optimization', 'Google Ads', 'SaaS Development',
  'Website Engineering', 'AI Automation', 'Email Campaigns', 'Meta Ads',
  'Brand Strategy', 'UI / UX Design', 'Conversion Rate Optimization',
  'WhatsApp Marketing', 'YouTube Ads', 'Analytics & Telemetry',
  'Content Marketing', 'Software Engineering',
];

const MarqueeTicker = ({
  reverse  = false,
  speed    = 42,
  light    = false,
  size     = 'sm',     // 'xs' | 'sm' | 'md'
  className = '',
}) => {
  const doubled = [...ITEMS, ...ITEMS];
  const sizeMap = { xs: 'text-[10px]', sm: 'text-[11px]', md: 'text-[13px]' };

  return (
    <div
      className={`overflow-hidden select-none w-full ${className}`}
      aria-hidden="true"
    >
      <div
        className="flex w-max"
        style={{
          animation: `${reverse ? 'tickerRev' : 'ticker'} ${speed}s linear infinite`,
          willChange: 'transform',
        }}
      >
        {doubled.map((item, i) => (
          <span
            key={i}
            className={`
              inline-flex items-center gap-5 pr-5
              font-semibold uppercase tracking-[0.2em]
              ${sizeMap[size]}
              ${light ? 'text-white/50' : 'text-[#5A635A]/55'}
            `}
          >
            {item}
            <span
              className={`
                w-1 h-1 rounded-full flex-shrink-0
                ${light ? 'bg-white/40' : 'bg-[#5A635A]/30'}
              `}
            />
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeTicker;
